var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorMessage || _vm.warningMessage)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"color":_vm.color}},'v-icon',attrs,false),on),[_vm._v(" fa-exclamation-circle ")])]}}],null,false,1335161775)},[_c('span',[_vm._v(" "+_vm._s(_vm.errorMessage || _vm.warningMessage)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }